import { render, staticRenderFns } from "./proposal-tabs.vue?vue&type=template&id=57317f10&"
import script from "./proposal-tabs.vue?vue&type=script&lang=js&"
export * from "./proposal-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports